import React from 'react';
import { SectionNotification, ButtonSize } from 'wix-ui-tpa/cssVars';
import AlertIcon from 'wix-ui-icons-common/on-stage/Alert';
import ErrorIcon from 'wix-ui-icons-common/on-stage/Error';
import { st, classes } from './SectionMessage.st.css';
import { SectionMessageHook } from './dataHooks';

export enum SectionMessageType {
  Error = 'error',
  Alert = 'alert',
  Default = 'default',
  Wired = 'wired',
}

export interface SectionMessageProps {
  text?: string;
  type: SectionMessageType;
  withoutIcon?: boolean;
  buttonText?: string;
  children?: React.ReactNode;
  buttonOnClick?: () => void;
  className?: string;
  notificationClassName?: string;
  dataHook?: string;
}

export const SectionMessage: React.FC<SectionMessageProps> = ({
  text,
  type,
  withoutIcon = false,
  buttonText = '',
  children,
  buttonOnClick,
  className,
  notificationClassName,
  dataHook,
}) => {
  const getIcon = () =>
    type === SectionMessageType.Error ? <ErrorIcon /> : <AlertIcon />;

  const shouldShowNotification = text || children;

  return shouldShowNotification ? (
    <div
      className={st(classes.root, className)}
      data-hook={SectionMessageHook.Section_Message}
    >
      <SectionNotification
        type={type}
        className={notificationClassName}
        data-hook={dataHook || SectionMessageHook.Section_Notification}
      >
        {!withoutIcon ? <SectionNotification.Icon icon={getIcon()} /> : null}
        <SectionNotification.Text>{text || children}</SectionNotification.Text>
        {buttonText ? (
          <SectionNotification.Button
            onClick={buttonOnClick}
            size={ButtonSize.tiny}
          >
            {buttonText}
          </SectionNotification.Button>
        ) : null}
      </SectionNotification>
    </div>
  ) : null;
};
